import * as WonOfferConstants from './won-offers.constants';

export default WonOfferConstants;
